<template>
  <Head title="Search Results" />
  <div
    class="max-w-7xl mx-auto my-8 bg-white rounded shadow divide-y transition-colors"
  >
    <template v-if="jobs.length">
      <JobCard
        v-for="job in jobs"
        :job="job"
        :key="job.id"
        class="hover:bg-gray-50 transition"
      />
    </template>
    <div v-else class="text-center py-12 space-y-4">
      <EmojiSadIcon class="inline-block h-16 w-16 text-gray-300" />
      <p class="font-medium text-sm text-gray-700">
        We couldn't find any jobs.
      </p>
    </div>

  </div>
</template>

<script>
import { Head } from "@inertiajs/inertia-vue3";
import { EmojiSadIcon } from "@heroicons/vue/outline";

import JobCard from "@/components/Jobs/JobCard";

export default {
  props: {
    jobs: Array,
  },

  data() {
    return {
    };
  },



  components: {
    Head,
    JobCard,
    EmojiSadIcon,
  },
};
</script>
